import { Grid } from '@material-ui/core';
import React from 'react';
import CallToActionCard from '../cards/moduleCard/callToActionCard';
import { DomPurifyContentContainer } from './styles';

function ActivityDelivery(props) {
  return (
    <Grid
      item
      container
      alignItems="center"
      xs={12}
      style={{
        backgroundColor: ''
      }}
    >
      {/* DOM PURIFY CONTENT */}
      <Grid
        item
        container
        alignItems="center"
        xs={12}
      >
        <DomPurifyContentContainer
          dangerouslySetInnerHTML={{
            __html: props.formValues.description,
          }}
        />
      </Grid>
      {/* CALL TO ACTION */}
      <Grid
        item
        container
        justify="center"
        alignItems="center"
        xs={12}
      >
        <CallToActionCard formValues={props.formValues} />
      </Grid>
    </Grid>
  );
}

export default ActivityDelivery;
